import React from "react"
import objectHelper from "@digits-shared/helpers/objectHelper"
import { type SortingState, type Table } from "@tanstack/react-table"

export const useVTableLoadingState = <TData extends object>(table: Table<TData>) => {
  const { sorting } = table.getState()
  // Track if sorting has changed since the last non-loading state
  const previousSort = React.useRef<SortingState>(null)
  const previousRowCount = React.useRef<number>(undefined)

  const loading = table.options.meta?.loading ?? false
  const { rows } = table.getRowModel()

  // Update tracking when loading state changes
  React.useEffect(() => {
    if (!loading) {
      // When loading stops, update the last known non-loading sort
      previousSort.current = sorting
      previousRowCount.current = rows.length
    }
  }, [loading, rows.length, sorting])

  const loadingInPlace = !objectHelper.deepEqual(sorting, previousSort.current) && loading
  const loadingInPlaceRows = loadingInPlace ? previousRowCount.current : undefined
  const empty = !loadingInPlace && !rows?.length

  return {
    loadingInPlace,
    loadingInPlaceRows,
    empty,
  }
}
